import { render, staticRenderFns } from "./BlockListCasesCustom.vue?vue&type=template&id=37214bdc"
import script from "./BlockListCasesCustom.vue?vue&type=script&lang=js"
export * from "./BlockListCasesCustom.vue?vue&type=script&lang=js"
import style0 from "./BlockListCasesCustom.vue?vue&type=style&index=0&id=37214bdc&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports